import { useApolloClient } from "@apollo/client";
import updateUserPreferencesMutation from "../graphql/updateUserPreferences.mutation.graphql";
import { PreferencesInput } from "@models/ISchema";
import { useState } from "react";

export const useUpdateUserPreferences = () => {
  const client = useApolloClient();
  const [isLoading, setIsLoading] = useState(false);

  const updateUserPreferences = async (preferences: PreferencesInput) => {
    try {
      setIsLoading(true);
      const response = await client.mutate({
        mutation: updateUserPreferencesMutation,
        variables: {
          input: preferences,
        },
      });

      setIsLoading(false);
      return response.data.updateUserPreferences;
    } catch (error) {
      console.error("Error updating user preferences:", error);
      setIsLoading(false);
      throw error;
    }
  };

  return {
    isLoading,
    updateUserPreferences,
  };
};
